import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Myanmar NRC generator following Single Responsibility Principle
 */
export class MmGenerator extends BaseGenerator {
  generate() {
    // State/Division code (1-14)
    const stateCode = this.randomInt(1, 14);
    
    // Township codes (common ones)
    const townships = ['BAMANA', 'DAPEIN', 'HLAING', 'INSEIN', 'KAMAYA', 'LANMAD', 'MAYANK', 'TAMANA', 'THAKIN', 'YANKIN'];
    const township = townships[this.randomInt(0, townships.length - 1)];
    
    // Citizenship type
    const citizenshipTypes = ['N', 'A', 'P']; // N=National, A=Associate, P=Naturalized
    const citizenshipType = citizenshipTypes[this.randomInt(0, citizenshipTypes.length - 1)];
    
    // Serial number (6 digits)
    const serialNumber = this.randomDigits(6);
    
    return `${stateCode}/${township}(${citizenshipType})${serialNumber}`;
  }
}